<template>
    <div class="form">
        <el-form style="margin:20px;width:60%;min-width:600px;" label-width="110px">
            <el-form-item class='edit-form' label="套餐名称">
                <el-input placeholder='请输入套餐名称(必填)' v-model="Form.ProName" v-if="!isView"></el-input>
                <span class="viewspan" v-else>{{Form.ProName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="套餐简称">
                <el-input placeholder='请输入套餐简称(必填)' v-model="Form.ProNick" v-if="!isView"></el-input>
                <span class="viewspan" v-else>{{Form.ProNick}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="套餐编号">
                <el-input placeholder='请输入套餐编号(必填)' v-model="Form.ProCode" v-if="!isView"></el-input>
                <span class="viewspan" v-else>{{Form.ProCode}}</span>
            </el-form-item>
            <el-form-item label="配置套餐">
                <template>
                    <div style="border:1px solid rgba(89, 89, 89, 0.24);margin-top:30px;width:500px;padding:10px;border-radius: 8px">
                        <template v-for="(item,index) in PackageItem">
                            <el-row>
                                <el-col :span="4" style="font-weight: bold">单品{{index+1}}</el-col>
                                <el-col :span="4" v-show="!isView">
                                    <el-button @click="ProductShow(index)">选择单品</el-button>
                                </el-col>
                            </el-row>
                            <el-row style="margin:10px 0" v-show="PackageItem[index].ProId">
                                <el-col :span="11">{{item.ProName}}</el-col>
                                <el-col :span="9" v-show="!isView">
                                    <el-input-number v-model="item.ProNum" :min="0"></el-input-number>
                                </el-col>
                                <el-col :span="3" style="margin-left: 2px">
                                    <span v-show="isView">{{item.ProNum}}</span>
                                    <span>({{item.ProUnit}})</span>
                                </el-col>
                            </el-row>
                        </template>
                        <el-row style="display: flex;justify-content: center;margin-top: 20px">
                            <el-button icon="plus" @click="addProduct" v-show="!isView">添加单品</el-button>
                        </el-row>
                    </div>
                </template>
            </el-form-item>
            <el-form-item label="发货仓库类型" required>
                <el-select placeholder="-请选择-" v-model='Form.StockType' v-show="this.isEdit">
                    <el-option v-for="option in StockTypeNames" :value="option.id" :label="option.name">
                    </el-option>
                </el-select>
                <span v-show="!this.isEdit" class="spanitem">{{Form.StockTypeName}}</span>
            </el-form-item>
            <el-form-item label="自然单位">
                <el-select placeholder="-请选择-" v-model="activeNaturalId" v-show="!isView">
                    <el-option v-for="option in naturalUnitsList" :value="option.Id" :label="option.ParmName">
                    </el-option>
                </el-select>
                <span v-show="isView" class="viewspan">{{Form.ProNaturalUnit}}</span>
                <el-button icon="plus" @click="UnitDialog(6)" v-show="!isView"></el-button>
            </el-form-item>
            <el-form-item label="销售单位">
                <el-select placeholder="-请选择-" v-model="activeSaleId" v-show="!isView">
                    <el-option v-for="option in saleUnitsList" :value="option.Id" :label="option.ParmName">
                    </el-option>
                </el-select>
                <span v-show="isView" class="viewspan">{{Form.ProSaleUnit}}</span>
                <el-button icon="plus" @click="UnitDialog(7)" v-show="!isView"></el-button>
            </el-form-item>
            <el-form-item style="width:500px" label="比例" v-if="!isView">
                <el-row>
                    <el-col :span="6">
                        <el-input v-model='Form.ProProportion1'></el-input>
                    </el-col>
                    <el-col :span="4" style="margin-left:2px" v-show='Form.ProNaturalUnit'>
                        <span v-show="!isView">({{Form.ProNaturalUnit}})</span>
                    </el-col>
                    <el-col :span="2">等于</el-col>
                    <el-col :span="6">
                        <el-input v-model='Form.ProProportion2'></el-input>
                    </el-col>
                    <el-col :span="5" style="margin-left: 2px" v-show='Form.ProSaleUnit'>
                        <span>({{Form.ProSaleUnit}})</span>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item style="width:500px" label="比例" v-else>
                <el-row class="viewspan">
                    <el-col :span="24">
                        <span style="margin-right: 15px">{{Form.ProProportion1}}({{Form.ProNaturalUnit}})</span> 等于
                        <span style="margin-left: 15px">{{Form.ProProportion2}}({{Form.ProSaleUnit}})</span>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="原价">
                <el-col :span="7">
                    <el-input placeholder="原价(必填)" v-model="Form.Price" v-show="this.isEdit"></el-input>
                </el-col>
                <el-col :span="2" v-show="this.isEdit">元</el-col>
                <span v-show="!this.isEdit" class="spanitem"> {{Form.Price}}</span>
            </el-form-item>
            <el-form-item label="销售价">
                <el-col :span="7">
                    <el-input placeholder="销售价(必填)" v-model="Form.SalePrice" v-show="this.isEdit"></el-input>
                </el-col>
                <el-col :span="2" v-show="this.isEdit">元</el-col>
                <span v-show="!this.isEdit" class="spanitem"> {{Form.SalePrice}}</span>
            </el-form-item>
            <el-form-item label="备注" width="100px">
                <el-input type="textarea" placeholder="请输入备注(选填)" v-model="Form.ProRemark" v-show="!isView"></el-input>
                <span v-show="isView" class="viewspan">
                    <span v-if="Form.ProRemark!=undefined&&Form.ProRemark!=''">{{Form.ProRemark}}</span>
                    <span v-else>--</span>
                </span>
            </el-form-item>
            <el-row>
                <el-col :span="24" style="display: flex;justify-content: center">
                    <el-button @click="submit" type="primary" v-show="!isView">确 定</el-button>
                    <el-button @click="pathBack" type="primary" v-show="isView">确 定</el-button>
                </el-col>
            </el-row>
        </el-form>
        <el-dialog :title="dialogTable.title" v-model="dialog.UnitShow" size="tiny" :close-on-click-modal="false" v-on:close="dialogClosed(1)">
            <el-table :data="dialogTable.data" style="width: 100%">
                <el-table-column prop="ParmName" :label="dialogTable.label" align="center">
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template scope="scope">
                        <el-button size="small" icon="delete" type="danger" @click="delTable(scope.$index, scope.row,dialogTable.type)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-row>
                    <el-col :span="16" style="margin-left: 20px">
                        <el-input v-model="dialogContent"></el-input>
                    </el-col>
                    <el-col :span="6">
                        <el-button type="primary" @click="addDialog(dialogTable.type)">添 加</el-button>
                    </el-col>
                </el-row>
            </span>
        </el-dialog>
        <el-dialog title="选择单品" v-model="dialog.ProShow" size="small" :close-on-click-modal="false" v-on:close="dialogClosed(2)">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="单品编号">
                    <el-input placeholder="请输入单品编号" style="width:150px" v-model="query.ProId"></el-input>
                </el-form-item>
                <el-form-item label="名称">
                    <el-input placeholder="请输入名称" style="width:150px" v-model="query.ProName"></el-input>
                </el-form-item>
                <el-form-item label="分类">
                    <el-select placeholder="-请选择-" style="width:150px" v-model="query.ProClass">
                        <el-option v-for="option in ProductClass" :value="option.Value" :label="option.Key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="种类">
                    <el-select placeholder="-请选择-" style="width:150px" v-model="query.ProAttr">
                        <el-option v-for="option in Category" :value="option.Id" :label="option.ParmName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getProList">查询</el-button>
                </el-form-item>
            </el-form>

            <el-row v-if="!loading2">
                <el-row v-if="ProductList.length>0">
                    <div style="width: 19%;display: inline-block;text-align: center;margin-top: 20px;overflow: hidden" v-for="item in ProductList">
                        <el-radio class="radio" :label="item.ProductId" v-model="activeProductId" style="float: left">{{item.ProName}}</el-radio>
                    </div>
                    <!-- <template v-for="item in ProductList">
                        <el-col :span="4" style="margin-top: 20px;">
                            <el-radio class="radio" :label="item.ProductId" v-model="activeProductId" style="float: left">{{item.ProName}}</el-radio>
                        </el-col>
                    </template>-->

                </el-row>
                <el-row v-else>
                    <el-col :span="24" style="margin-top: 20px;text-align: center">
                        <span>暂无数据</span>
                    </el-col>
                </el-row>
            </el-row>
            <el-row v-else>
                <div style="text-align: center">正在加载数据中.....</div>
            </el-row>
            <el-row style="margin-top: 50px;display: flex;justify-content: flex-end;margin-bottom: -10px">
                <el-pagination v-show="ProductList.length>0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pageSize" layout="total, prev, pager, next" :total="totalSize*1">
                </el-pagination>
            </el-row>
            <span slot="footer" class="dialog-footer" style="display: flex;justify-content: center">
                <el-button type="primary" @click="ProductSure()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import addPackage from "./addPackage.js";
module.exports = addPackage;
</script>

<style scoped lang="scss">
.edit-form {
  width: 370px;
}

.viewspan {
  margin-left: 25px;
}

.viewTem {
  @inclued viewspan;
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// addPackage.vue?496615f5